<style scoped>

</style>

<template>
  <div>
    <div>
      <v-textarea
        id="template_name_input"
        ref="templateName"
        :label="translate('ui_template_name')"
        v-model="$store.state.activeTemplate.name"
        required
        outlined
        dense
        hide-details
        background-color="white"
        rows="1"
        @change="$store.dispatch('saveRemoteTemplate')"
      ></v-textarea>

      <v-textarea
        :label="translate('ui_template_description')"
        v-model="$store.state.activeTemplate.description"
        outlined
        dense
        hide-details
        background-color="white"
        auto-grow
        rows="1"
        @change="$store.dispatch('saveRemoteTemplate')"
        style="margin-top: 20px;"
      ></v-textarea>

      <div
        v-if="$store.state.user.settings.allowShareTemplates && $store.state.mode !== 'static'"
        style="display: flex; flex-direction: column; justify-content: space-between; margin-top: 20px;"
      >
        <v-switch
          v-if="$store.state.loggedin"
          v-model="$store.state.activeTemplate.isPublished"
          @change="onPublishToggle"
          :label="( translate('ui_publish_btn') )"
          dense
          style="margin: 0;"
          hide-details
        ></v-switch>

        <v-switch
          v-if="!$store.state.loggedin"
          dense
          :label="( translate('ui_publish_btn') )"
          disabled
          style="margin: 0;"
          hide-details
        ></v-switch>

        <div style="font-size: 12px; line-height: 1.2;">{{ translate('ui_can_publish_prompt') }}</div>

        <v-alert
          v-if="$store.state.activeTemplate.isPublished"
          outlined
          style="padding: 10px; font-size: 12px;"
          color="success"
        >{{ translate('ui_is_published_prompt') }}</v-alert>

        <v-alert
          v-if="!$store.state.loggedin"
          outlined
          style="padding: 10px; margin-top: 10px;"
        >
          <div
            style="font-size: 12px; line-height: 1.3; color: #6a6a6a;"
          >
            <router-link to="/">
              {{ translate('ui_login_signin') }}
            </router-link>
            {{ translate('ui_publish_prompt_sign_in') }}
          </div>
          <div></div>
        </v-alert>
      </div>

      <div
        style="display: none; margin-top: 10px;"
      >
        <div style="width: 50%;">
          {{ translate('ui_autosave') }}:
          <v-switch
            v-model="autosave"
            :label="translate('ui_autosave_every_minute')"
            style="margin-top: 0;"
          ></v-switch>
        </div>

        <div
          v-if="$store.state.user.languages.length > 1"
        >
          <div>
            {{ translate('ui_language') }}:
          </div>
          <v-radio-group
            v-model="$store.state.activeTemplate.language"
            style="margin-top: 0;"
          >
            <v-radio
              v-for="n in $store.state.user.languages"
              :key="n.id"
              :label="n.name"
              :value="n.id"
            ></v-radio>
          </v-radio-group>
        </div>
      </div>

      <div
        style="margin-top: 10px; display: none;"
      >
        <div style="">
          <div>
            {{ translate('modules_placement') }}:
          </div>
          <v-radio-group
            v-model="$store.state.activeTemplate.layout.sheetPerModule"
            style="margin-top: 0;"
          >
            <v-radio
              :value="0"
              :label="translate('modules_on_single_sheets')"
            ></v-radio>
            <v-radio
              :value="1"
              :label="translate('modules_on_separate_sheets')"
            ></v-radio>
          </v-radio-group>
        </div>
      </div>

      <div v-if="$store.state.user.settings.plan === 0" style="border: 1px solid red; padding: 10px;">
        <v-btn
          @click="onGetAnalytics"
        ></v-btn>

        <v-checkbox
          style="margin: 0; height: 30px;"
          v-model="$store.state.activeTemplate.isLocked"
          label="Locked"
        ></v-checkbox>

        <v-checkbox
          style="margin: 0; height: 30px;"
          v-model="$store.state.activeTemplate.debug.showXMLFormulas"
          label="Show XML formulas"
        ></v-checkbox>

        <v-checkbox
          style="margin: 0; height: 30px;"
          v-model="$store.state.activeTemplate.debug.showFormulas"
          label="Show formulas"
        ></v-checkbox>

        <v-checkbox
          style="margin: 0; height: 30px;"
          v-model="$store.state.activeTemplate.debug.showColId"
          label="Show showColId"
        ></v-checkbox>

        <v-checkbox
          style="margin: 0; height: 30px;"
          v-model="$store.state.activeTemplate.debug.showStyles"
          label="Show showStyles"
        ></v-checkbox>
      </div>
    </div>

  </div>
</template>

<script>

import Mixin from '../../mixins/mixin';


export default {
  name: 'SectionGeneralDialog',
  components: {},
  mixins: [Mixin],
  props: ['section'],
  data: () => ({
    dialogAssumptions: [],
  }),
  methods: {
    onGetAnalytics() {
      this.$store.dispatch('getAnalytics');
    },
    onPublishToggle() {
      this.$store.dispatch('publishTemplate', this.$store.state.activeTemplate.isPublished);
    },
  },
  computed: {
    autosave: {
      get() {
        return this.$store.state.activeTemplate.autosaveMinutes;
      },
      set(value) {
        this.$store.dispatch('updateState', {
          path: 'activeTemplate.autosaveMinutes',
          value,
        });
        if (value === true) {
          // this.startAutoSave();
        } else {
          const { autoSavingInterval } = this.$store.state;
          clearInterval(autoSavingInterval);
          this.$store.dispatch('updateState', {
            path: 'autoSavingInterval',
            value: null,
          });
        }
      },
    },
  },
};
</script>
